import getCombatantById from "./getCombatantById";
//-----------------------------
// is valid combatant reaction
//-----------------------------
export default function isValidRection(id, reaction) {
  let c = getCombatantById(id);
  //---------------------
  // check reaction value
  //---------------------
  switch (reaction) {
    //----------
    // 1. parry
    //----------
    case "parry":
      return true;
    //----------
    // 2. dodge
    //----------
    case "dodge":
      return true;
    //-----------
    // 3. magic
    //-----------
    case "magic_reaction":
      if (c.magic) {
        return true;
      } else {
        return false;
      }
    //----------------------
    // 4. special_reaction
    //----------------------
    case "special_reaction":
      if (c.special_reaction) {
        return true;
      } else {
        return false;
      }
    //----------------
    // return default
    //----------------
    default:
      return true;
  }
}
